export const products = [
  {
    id: 1,
    title: 'La Aco',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656648456/coding/NucbaZappi/Productos/muzza-mentolada_fmh9at.png',
    desc: 'Cheta la gorra',
    price: 3000,
    category: 'Pizzas',
  },
  {
    id: 2,
    title: '¡Q Jamone!',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656648456/coding/NucbaZappi/Productos/jamone_w502kt.png',
    desc: 'c/jamón crudo',
    price: 350,
    category: 'Pizzas',
  },
  {
    id: 3,
    title: 'La Charly García',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656648456/coding/NucbaZappi/Productos/charly_c3l5uz.png',
    desc: '¡BASTA!',
    price: 380,
    category: 'Pizzas',
  },
  {
    id: 4,
    title: 'La Maradona',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656648456/coding/NucbaZappi/Productos/maradona_nwup0z.png',
    desc: '¡ETERNA!',
    price: 450,
    category: 'Pizzas',
  },
  {
    id: 5,
    title: 'Picantovich',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656648455/coding/NucbaZappi/Productos/picantovich_fhy8us.png',
    desc: 'Pica 2 veces',
    price: 750,
    category: 'Pizzas',
  },
  {
    id: 6,
    title: 'La Hasbulla',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656648456/coding/NucbaZappi/Productos/hasbulla_edbxfh.png',
    desc: 'En honor al 1',
    price: 990,
    category: 'Pizzas',
  },
  {
    id: 7,
    title: 'Leo Messi',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656648455/coding/NucbaZappi/Productos/messi_m2l6zt.png',
    desc: '¡De pie señores!',
    price: 10,
    category: 'Pizzas',
  },
  {
    id: 8,
    title: 'Nick Gi',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656648456/coding/NucbaZappi/Productos/nick_ze570j.png',
    desc: 'La que desaparece',
    price: 1,
    category: 'Pizzas',
  },
  {
    id: 9,
    title: 'Magic Alonso',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653724/coding/NucbaZappi/Productos/HamburgesaMagicAlonso_xfpng8.png',
    desc: 'El mejor plan',
    price: 800,
    category: 'Hamburguesas',
  },
  {
    id: 10,
    title: 'Doble 5 + Papas',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653724/coding/NucbaZappi/Productos/Ladoble5_Papas_ywcdxx.png',
    desc: 'Que viva el fulbo!',
    price: 750,
    category: 'Hamburguesas',
  },
  {
    id: 11,
    title: 'La Krupoviesa ',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653724/coding/NucbaZappi/Productos/LaKrupoviesa_j7da47.png',
    desc: 'Con de todo',
    price: 550,
    category: 'Hamburguesas',
  },
  {
    id: 12,
    title: 'La Gallina',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653724/coding/NucbaZappi/Productos/LaGallina_yrygtq.png',
    desc: 'Todo pollo',
    price: 912,
    category: 'Hamburguesas',
  },
  {
    id: 13,
    title: 'Classic',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653723/coding/NucbaZappi/Productos/Classic_p4hqus.png',
    desc: 'Para personas sin actitud',
    price: 150,
    category: 'Napapuki',
  },
  {
    id: 14,
    title: 'Copiadas',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653723/coding/NucbaZappi/Productos/Copiadas_mo6tqu.png',
    desc: 'Simil Krachitos',
    price: 250,
    category: 'Napapuki',
  },
  {
    id: 15,
    title: 'Las Acordeónes',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653724/coding/NucbaZappi/Productos/LasAcorde%C3%B3nes_x52amb.png',
    desc: 'Con esa formita',
    price: 350,
    category: 'Napapuki',
  },
  {
    id: 16,
    title: 'Rústica',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653725/coding/NucbaZappi/Productos/R%C3%BAstica_jqgcvy.png',
    desc: 'Como Godin ',
    price: 400,
    category: 'Napapuki',
  },
  {
    id: 17,
    title: 'Clasica a la piedra',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653723/coding/NucbaZappi/Productos/ClasicaAlaPiedra_jjd5nz.png',
    desc: 'Con mucha mufa ',
    price: 425,
    category: 'PizzasALaPiedra',
  },
  {
    id: 18,
    title: 'Zapatilla',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653722/coding/NucbaZappi/Productos/Zapatilla_f4igih.png',
    desc: 'Calzado 45',
    price: 440,
    category: 'PizzasALaPiedra',
  },
  {
    id: 19,
    title: 'La Sutil',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653724/coding/NucbaZappi/Productos/LaSutil_bmbbms.png',
    desc: 'Para toda la familia',
    price: 470,
    category: 'PizzasALaPiedra',
  },
  {
    id: 20,
    title: 'Picante',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653724/coding/NucbaZappi/Productos/Picante_wgb8pm.png',
    desc: 'Como React',
    price: 495,
    category: 'PizzasALaPiedra',
  },
  {
    id: 21,
    title: 'Rejunte',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653725/coding/NucbaZappi/Productos/Rejunte_bsyiqo.png',
    desc: 'Con todo lo que sobre',
    price: 500,
    category: 'Wraps',
  },
  {
    id: 22,
    title: 'El Inter de Milán',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653723/coding/NucbaZappi/Productos/ElInterdeMil%C3%A1n_voak5h.png',
    desc: 'Estilo italiano',
    price: 770,
    category: 'Wraps',
  },
  {
    id: 23,
    title: 'Vegetariano',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653722/coding/NucbaZappi/Productos/Vegetariano_axmpeb.png',
    desc: 'Sin carne ni pollo',
    price: 500,
    category: 'Wraps',
  },
  {
    id: 24,
    title: 'Mediterráneo',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653724/coding/NucbaZappi/Productos/Mediterr%C3%A1neo_mhvzvm.png',
    desc: 'Con pescado',
    price: 980,
    category: 'Wraps',
  },
  {
    id: 25,
    title: 'Di Maria',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653723/coding/NucbaZappi/Productos/DiMaria_wfztyj.png',
    desc: 'El mejor Taco',
    price: 1100,
    category: 'MexicanFood',
  },
  {
    id: 26,
    title: 'Ortega',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653724/coding/NucbaZappi/Productos/Ortega_jkxknz.png',
    desc: 'Un burrito con calidad',
    price: 1010,
    category: 'MexicanFood',
  },
  {
    id: 27,
    title: 'Ta bien Mexicano',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653722/coding/NucbaZappi/Productos/TaBienMexicano_qdqlew.png',
    desc: 'O tamal Mexicano',
    price: 1250,
    category: 'MexicanFood',
  },
  {
    id: 28,
    title: 'El paso',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653723/coding/NucbaZappi/Productos/ElPaso_cup3pw.png',
    desc: 'Burrito de Hank',
    price: 1350,
    category: 'MexicanFood',
  },
  {
    id: 29,
    title: 'After React',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653723/coding/NucbaZappi/Productos/AfterReact_iez607.png',
    desc: 'Para despues de codear',
    price: 800,
    category: 'Batidukis',
  },
  {
    id: 30,
    title: 'Linea de 3',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653724/coding/NucbaZappi/Productos/LineaDe3_rt3uik.png',
    desc: 'Los que sobren del fondo',
    price: 999,
    category: 'Batidukis',
  },
  {
    id: 31,
    title: 'Frutilla',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653723/coding/NucbaZappi/Productos/Frutilla_tzcj6a.png',
    desc: 'Pinta verano',
    price: 1100,
    category: 'Batidukis',
  },
  {
    id: 32,
    title: 'Nucbastar',
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656653724/coding/NucbaZappi/Productos/Nucbastar_sio3g0.png',
    desc: 'No trates de entenderlo',
    price: 700,
    category: 'Batidukis',
  },
];

export const TotalProducts = products.length;

export const Products = products.reduce((acc, product) => {
  if (!acc[product.category]) {
    acc[product.category] = [];
  }

  acc[product.category] = [...acc[product.category], product];

  return acc;
}, {});
